import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import LeiService from '../../../../../services/leis-auth';
import { Link, Navigate, useParams } from 'react-router-dom';



const FormEmenta = () => {
    const [ementa, setEmenta] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchLei(id) {
        const response = await LeiService.leiEdit(id);
        setEmenta(response.data["ementa"]);
    }

    useEffect(() => {
        fetchLei(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const lei = await LeiService.editar(id, {
                ementa: ementa
            })
            if (lei.data["cod_lei"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={10}>
                                    <Form.Group className="mb-3" controlId="ementa">
                                        <FloatingLabel
                                            label="Ementa"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="textarea"
                                                name="ementa"
                                                value={ementa}
                                                onChange={e => setEmenta(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/restrito/leis/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Lei editada com sucesso!</Alert>
                <Navigate to={'/restrito/leis/listar'} />
            </Fragment>
        )
    }
}

export default FormEmenta